import type { ServerResponse } from "http";

// Marks a server render whose data could not be fetched at all, so the response can't be mistaken for a healthy page.
// Kept on the response object itself rather than in a module-level variable: concurrent renders share the module, but
// each one has its own response
const SSR_FAILURE = Symbol.for("fundamentei.ssrFailure");

const DEFAULT_RETRY_AFTER_IN_SECONDS = 60;
const MAX_RETRY_AFTER_IN_SECONDS = 3600;

export function hasSsrFailed(response: ServerResponse | null | undefined): boolean {
  return !!response && (response as any)[SSR_FAILURE] === true;
}

export function markSsrAsFailed(
  response: ServerResponse | null | undefined,
  httpStatus: 429 | 503,
  retryAfterInSeconds?: number,
): void {
  if (!response || response.headersSent) {
    return;
  }

  (response as any)[SSR_FAILURE] = true;

  response.statusCode = httpStatus;
  response.setHeader("Retry-After", String(toRetryAfter(retryAfterInSeconds)));
  response.setHeader("Cache-Control", "no-store");
}

function toRetryAfter(retryAfterInSeconds: number | undefined): number {
  if (typeof retryAfterInSeconds !== "number" || !Number.isFinite(retryAfterInSeconds) || retryAfterInSeconds <= 0) {
    return DEFAULT_RETRY_AFTER_IN_SECONDS;
  }
  return Math.min(Math.ceil(retryAfterInSeconds), MAX_RETRY_AFTER_IN_SECONDS);
}
